import { fromJS } from 'immutable';

import {
  REQUEST_CLIENTS_REQUIRING_ATTENTION,
  REQUEST_CLIENTS_REQUIRING_ATTENTION_SUCCESS,
  REQUEST_CLIENTS_REQUIRING_ATTENTION_FAILURE,
} from './types';

const initialState = fromJS({
  data: false,
  network: {
    loading: false,
    error: false,
  },
});

export function clientsRequiringAttentionRequest(entityId) {
  return {
    type: REQUEST_CLIENTS_REQUIRING_ATTENTION,
    entityId,
  };
}

export function clientsRequiringAttentionSuccess(response) {
  return {
    type: REQUEST_CLIENTS_REQUIRING_ATTENTION_SUCCESS,
    response,
  };
}

export function clientsRequiringAttentionFailure(error) {
  return {
    type: REQUEST_CLIENTS_REQUIRING_ATTENTION_FAILURE,
    error,
  };
}

const clientsRequiringAttentionReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CLIENTS_REQUIRING_ATTENTION:
      return state.setIn(['network', 'loading'], true);
    case REQUEST_CLIENTS_REQUIRING_ATTENTION_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], false)
          .set('data', fromJS(action.response)),
      );
    case REQUEST_CLIENTS_REQUIRING_ATTENTION_FAILURE:
      return state.withMutations((s) =>
        s.setIn(['network', 'loading'], false).setIn(['network', 'error'], action.error),
      );
    default:
      return state;
  }
};

export default clientsRequiringAttentionReducer;
